import React from "react";
import { UIAuthContainer, UIButton, UIIcon, UITranslator } from "components";
import { LeanCard, LeanFlagSelect, LeanInput } from "../../../lean-components/LeanComponents";
import { Link } from "react-router-dom";
import { Form, FormGroup, Alert } from "reactstrap";
import { useFormWithValidation } from "./PasswordResetViewData";
import { useTranslator } from "lean-util/LeanTranslator";
import { ImgLeanLogo, ImgLeanLogoLight } from "lean-util/LeanImages";
import Head from "../../../layout/head/Head";
import AuthFooter from "../AuthFooter";
import LeanPaths from "lean-util/LeanPaths";
import PasswordResetViewModel from "./PasswordResetViewModel";



const PasswordResetView = () =>
{
    // MARK: - Properties

    const viewModel = PasswordResetViewModel();
    const { formState, register, handleSubmit } = useFormWithValidation()
    const { errors } = formState
    const { translate } = useTranslator()


    // MARK: - Actions

    const onSubmit = (formData) =>
    {
        viewModel.send(formData)
    }


    // MARK: - Render

    return (
        <>
            <Head title={translate("passwordResetTitle")} />
            <LeanFlagSelect />
            <UIAuthContainer>
                <div className="nk-block-middle nk-auth-body  wide-xs">

                    <div className="brand-logo pb-4 text-center">
                        <Link to={LeanPaths.auth.login} className="logo-link">
                            <img className="logo-light logo-img logo-img-lg" src={ImgLeanLogoLight} alt="logo" />
                            <img className="logo-dark logo-img logo-img-lg" src={ImgLeanLogo} alt="logo-dark" />
                        </Link>
                    </div>

                    <LeanCard bodyClassName="card-inner-lg">
                        <h4>
                            <UITranslator id="passwordResetTitle" />
                        </h4>

                        <p className="text-soft">
                            <UITranslator id="passwordResetSubtitle" />
                        </p>

                        {viewModel.errorMessage && (
                            <div className="mb-3">
                                <Alert color="danger" className="alert-icon">
                                    <UIIcon name="alert-circle" /> {viewModel.errorMessage}
                                </Alert>
                            </div>
                        )}

                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <FormGroup>
                                <LeanInput
                                    type="password"
                                    id="newPassword"
                                    className="form-control-lg"
                                    label={translate("passwordResetPasswordLabel") + "*"}
                                    placeholder={translate("passwordResetPasswordPlaceholder")}
                                    register={register}
                                    error={errors.newPassword} />
                            </FormGroup>
                            <FormGroup>
                                <LeanInput
                                    type="password"
                                    id="confirmPassword"
                                    className="form-control-lg"
                                    label={translate("passwordResetConfirmPasswordLabel") + "*"}
                                    placeholder={translate("passwordResetConfirmPasswordPlaceholder")}
                                    register={register}
                                    error={errors.confirmPassword} />
                            </FormGroup>
                            <FormGroup>
                                <UIButton type="submit" className="btn-block" color="primary" size="lg" isLoading={viewModel.isLoading}>
                                    {translate("update")}
                                </UIButton>
                            </FormGroup>
                        </Form>

                        <div className="form-note-s2 text-center pt-4">
                            <Link to={LeanPaths.auth.login}>
                                <strong>
                                    <UITranslator id="backToLoginPage" />
                                </strong>
                            </Link>
                        </div>

                    </LeanCard>
                </div>
                <AuthFooter />
            </UIAuthContainer>
        </>
    );
};

export default PasswordResetView;